module.exports = __webpack_public_path__ + "img/banner_aviation_m.32ec0722.png";